import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { Helmet } from "react-helmet";

const ChatBot = () => {
  const [isVisible, setIsVisible] = useState(false);

  const businessNumber = "918106938625"; // Your business number
  const greetingMessage = "Hello! I am interested in your services."; // Pre-filled greeting
  const whatsappLink = `https://wa.me/${businessNumber}?text=${encodeURIComponent(
    greetingMessage
  )}`;

  // Show button after scrolling down
  useEffect(() => {
    const toggleVisibility = () => setIsVisible(window.scrollY > 200);
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      {/* SEO / Structured Data */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Quadrangle Solutions",
            url: "https://www.quadranglesolutions.com",
            logo: "https://www.quadranglesolutions.com/logo.png",
            sameAs: [
              "https://www.facebook.com/quadranglesolutions",
              "https://www.linkedin.com/company/quadranglesolutions",
              "https://twitter.com/quadranglesolutions",
            ],
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: `+${businessNumber}`,
                contactType: "customer service",
                areaServed: "IN",
              },
            ],
          })}
        </script>
      </Helmet>

      {/* WhatsApp Floating Button */}
      {isVisible && (
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{ zIndex: 9999 }} // Ensure button is above other elements
          className="fixed bottom-5 right-5 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-all"
        >
          <FaWhatsapp size={40} /> {/* Increased size for visibility */}
        </a>
      )}
    </>
  );
};

export default ChatBot;
